import { Component } from '@angular/core';

@Component({
  selector: 'app-infrastructure-banner',
  templateUrl: './infrastructure-banner.component.html',
  styleUrls: ['./infrastructure-banner.component.scss']
})
export class InfrastructureBannerComponent {

}
